import {Box, Text, Title} from '@mantine/core';
import React, {type FC} from 'react';
import {useRecruitmentList} from '../../../../core/repositories/recruitingInfoRepository';
import {useAuth} from '../../../../core/usecases/auth/AuthContext';
import {CardForPc} from '../../../recruitingInfo/components/Container/Presenter/CardForPc';
import {CardForSp} from '../../../recruitingInfo/components/Container/Presenter/CardForSp';

type Props = {
  industryIds: number[];
};

export const RecommendRecruitmentList: FC<Props> = ({industryIds}) => {
  const {user} = useAuth();
  const {data: recruitmentList} = useRecruitmentList({
    queryParams: {
      order: 'recommend',
      industryIDs: industryIds,
      gy: user?.graduationYear,
      allgy: (user?.graduationYear === undefined).toString(),
      page: 1,
      limit: 4,
    },
    config: {
      enabled: industryIds.length > 0,
    },
  });

  return (
    <>
      {recruitmentList && recruitmentList?.recruitments.length > 0 && (
        <Box className="w-full py-16">
          <Box
            id="recommend-recruitments"
            className="flex w-full justify-between"
          >
            <Title order={3}>
              <Text className="font-bold p-8">
                このコラムを見ている方におすすめの募集
              </Text>
            </Title>
          </Box>
          <Box className="flex flex-col">
            {recruitmentList?.recruitments.map((recruitment) => (
              <React.Fragment key={recruitment.id}>
                <div
                  key={`pc-${recruitment.id}`}
                  className="hidden pc:inline-block"
                >
                  <CardForPc recruitment={recruitment} className="mb-16" />
                </div>
                <div key={`sp-${recruitment.id}`} className="pc:hidden">
                  <CardForSp recruitment={recruitment} className="border-t-2" />
                </div>
              </React.Fragment>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};
